"use client";

import Script from "next/script";

import { X_PIXEL_ID } from "@/lib/analytics/x-ids";

declare global {
  interface Window {
    twq?: (command: string, ...args: unknown[]) => void;
  }
}

interface XPixelProps {
  strategy?: "afterInteractive" | "lazyOnload";
}

export function XPixel({ strategy = "lazyOnload" }: XPixelProps = {}) {
  if (process.env.NODE_ENV === "development") return null;

  return (
    <>
      <Script
        id="x-pixel-init"
        strategy={strategy}
      >
        {`!function(e,t,n,s,u,a){e.twq||(s=e.twq=function(){s.exe?s.exe.apply(s,arguments):s.queue.push(arguments);},s.version='1.1',s.queue=[])}(window,document,'script');twq('config','${X_PIXEL_ID}');`}
      </Script>
      <Script
        id="x-pixel-uwt"
        src="https://static.ads-twitter.com/uwt.js"
        strategy={strategy}
      />
    </>
  );
}
